import { ChronicCareSubscriptionStatus } from "./index"

export const SET_THEME = "SET_THEME"
export const UPDATE_CURRENT_DOCTOR_TENANT = "UPDATE_CURRENT_DOCTOR_TENANT"

/*Doctor Profile*/
export const SET_DOCTOR_PROFILE = "SET_DOCTOR_PROFILE"

/*Account Data*/
export const FETCH_ACCOUNT_DATA_SUCCESS = "FETCH_ACCOUNT_DATA_SUCCESS"
export const UPDATE_ACCOUNT_DATA = "UPDATE_ACCOUNT_DATA"
/*Static Data*/
export const UPDATE_STATIC_DATA = "UPDATE_STATIC_DATA"
export const UPDATE_PLAN_STATIC_DATA = "UPDATE_PLAN_STATIC_DATA"
export const UPDATE_USER_ID = "UPDATE_USER_ID"

/*Chat*/
export const UPDATE_WHATSAPP_NAMESPACE = "UPDATE_WHATSAPP_NAMESPACE"

export enum PatientSubscriptionsActionTypes {
	FETCH_ACTIVE = "FETCH_ACTIVE",
	FETCH_UPCOMING = "FETCH_UPCOMING",
	FETCH_EXPIRED = "FETCH_EXPIRED",
}
export const subscriptionStatusActionMap: Record<ChronicCareSubscriptionStatus, PatientSubscriptionsActionTypes> = {
	ACTIVE: PatientSubscriptionsActionTypes.FETCH_ACTIVE,
	UPCOMING: PatientSubscriptionsActionTypes.FETCH_UPCOMING,
	EXPIRED: PatientSubscriptionsActionTypes.FETCH_EXPIRED,
}

export const UPDATE_CONSULT_PAGE_DOCTOR_TYPE_SELECTION = "UPDATE_CONSULT_PAGE_DOCTOR_TYPE_SELECTION"
export const OngoingDoctorConsultationActionNames = {
	UPDATE_DOCTOR_CONSULTATION_DATA: "UPDATE_DOCTOR_CONSULTATION_DATA",
	APPOINTMENT_DATA_FETCH_SUCCESS: "APPOINTMENT_DATA_FETCH_SUCCESS",
	MEDICAL_PROFILE_DATA_FETCH_SUCCESS: "MEDICAL_PROFILE_DATA_FETCH_SUCCESS",
	USER_PROFILE_DATA_FETCH_SUCCESS: "USER_PROFILE_DATA_FETCH_SUCCESS",
	USER_ATTRIBUTES_DATA_FETCH_SUCCESS: "USER_ATTRIBUTES_DATA_FETCH_SUCCESS",
	PATIENT_VITALS_FETCH_SUCCESS: "PATIENT_VITALS_FETCH_SUCCESS",
	PATIENT_MEDICINE_PRESCRIPTION_FETCH_SUCCESS: "PATIENT_MEDICINE_PRESCRIPTION_FETCH_SUCCESS",
	PAST_PRESCRIPTIONS_FETCH_SUCCESS: "PAST_PRESCRIPTIONS_FETCH_SUCCESS",
	PRESCRIPTION_ADHERENCE: "PRESCRIPTION_ADHERENCE",
	PRESCRIPTION_ADHERENCE_IN_PDF: "PRESCRIPTION_ADHERENCE_IN_PDF",
	PRESCRIPTION_ACTIVE_GOALS: "PRESCRIPTION_ACTIVE_GOALS",
	PRESCRIPTION_ACTIVE_GOALS_IN_PDF: "PRESCRIPTION_ACTIVE_GOALS_IN_PDF",
	CLEAR_ONGOING_CONSULTATION_DATA: "CLEAR_ONGOING_CONSULTATION_DATA",
	FETCH_PATIENT_IN_CENTER_DATA_SUCCESS: "FETCH_PATIENT_IN_CENTER_DATA_SUCCESS",
	UPDATE_APPOINTMENT_STATUS: "UPDATE_APPOINTMENT_STATUS",
	UPDATE_AI_PRESCRIPTION_SUGGESTIONS: "UPDATE_AI_PRESCRIPTION_SUGGESTIONS",
}

export const PatientDataActionsNames = {
	FETCH_PATIENT_PERSONAL_PROFILE_SUCCESS: "FETCH_PATIENT_PERSONAL_PROFILE_SUCCESS",
	UPDATE_PATIENT_DETAILS: "UPDATE_PATIENT_DETAILS",
	UPDATE_PATIENT_ACTIVE_PACK_DETAILS: "UPDATE_PATIENT_ACTIVE_PACK_DETAILS",
	CLEAR_PATIENT_ALL_DATA: "CLEAR_PATIENT_ALL_DATA",
	UPDATE_DOCTOR_PREFERENCE: "UPDATE_DOCTOR_PREFERENCE",
	UPDATE_APPOINTMENTS_FOR_PATIENT: "UPDATE_APPOINTMENTS_FOR_PATIENT",
	FETCH_USER_ATTRIBUTES_SUCCESS: "FETCH_USER_ATTRIBUTES_SUCCESS",
	UPDATE_USER_CONTACT_NUMBER: "UPDATE_USER_CONTACT_NUMBER",
	UPDATE_USER_TENANT: "UPDATE_USER_TENANT",
	UPDATE_FITNESS_LEVEL: "UPDATE_FITNESS_LEVEL",
	FETCH_LAST_COMPLETED_APPOINTMENT_FOR_PATIENT_SUCCESS: "FETCH_LAST_COMPLETED_APPOINTMENT_FOR_PATIENT_SUCCESS",
	UPDATE_USER_MANUAL_TAGS: "UPDATE_USER_MANUAL_TAGS",
}

export const UPDATE_SUBSECTION_SUGGESTIONS = "UPDATE_SUBSECTION_SUGGESTIONS"

export const TwilioActions = {
	SET_HAS_PATIENT_JOINED_TWILIO_CONSULT: "SET_HAS_PATIENT_JOINED_TWILIO_CONSULT",
}

export const UPDATE_PDF_CONSTITUENTS = "UPDATE_PDF_CONSTITUENTS"
export const UPDATE_CAMERA_MIC_ACCESS_AVAILABLE_STATUS = "UPDATE_CAMERA_MIC__ACCESS_AVAILABLE_STATUS"

export const CoachConsultationActionTypes = {
	SAVE_CONSULT_DATA_FROM_REDIS: "SAVE_CONSULT_DATA_FROM_REDIS",

	SET_TAB_CONFIG: "SET_TAB_CONFIG",
	UPDATE_OPENED_TAB: "UPDATE_OPENED_TAB",
	UPDATE_CONSULT_TAB_DATA: "UPDATE_CONSULT_TAB_DATA",
	SAVE_CONSULT_SECTION_RECOMMENDATIONS: "SAVE_CONSULT_SECTION_RECOMMENDATIONS",
	FETCH_COACH_ONGOING_CONSULT_DETAILS_SUCCESS: "FETCH_COACH_ONGOING_CONSULT_DETAILS_SUCCESS",
	SAVE_MEDICAL_PROFILE: "SAVE_MEDICAL_PROFILE",
	SAVE_HISTORY_TAB_DATA: "SAVE_HISTORY_TAB_DATA",
	UPDATE_EDITED_MEDICAL_PROFILE: "UPDATE_EDITED_MEDICAL_PROFILE",
	UPDATE_EDITED_PATIENT_PERSONAL_PROFILE: "UPDATE_EDITED_PATIENT_PERSONAL_PROFILE",
	UPDATE_EDITED_USER_ATTRIBUTE: "UPDATE_EDITED_USER_ATTRIBUTE",
	SAVE_PATIENT_PERSONAL_PROFILE: "SAVE_PATIENT_PERSONAL_PROFILE",

	SAVE_PATIENT_INTERVENTION: "SAVE_PATIENT_INTERVENTION",
	UPDATE_PATIENT_INTERVENTION: "UPDATE_PATIENT_INTERVENTION",

	SAVE_PATIENT_GOALS: "SAVE_PATIENT_GOALS",
	UPDATE_PATIENT_GOALS: "UPDATE_PATIENT_GOALS",

	SAVE_PATIENT_DIET_PLAN: "SAVE_PATIENT_DIET_PLAN",
	UPDATE_PATIENT_DIET_PLAN: "UPDATE_PATIENT_DIET_PLAN",

	SAVE_USER_ATTRIBUTES: "SAVE_USER_ATTRIBUTES",
	UPDATE_USER_ATTRIBUTES: "UPDATE_USER_ATTRIBUTES",

	UPDATE_DELETED_GOAL_IDS: "UPDATE_DELETED_GOAL_IDS",

	UPDATE_WIDGETS_DATA: "UPDATE_WIDGETS_DATA",

	MARK_DATA_FETCHED: "MARK_DATA_FETCHED",
	MARK_UNSAVED_CHANGES: "MARK_UNSAVED_CHANGES",

	DELETE_PATIENT_PLAN: "DELETE_PATIENT_PLAN",

	UPDATE_WIDGETS_ERROR: "UPDATE_WIDGETS_ERROR",
	UPDATE_WIDGETS_MANDATORY_STATUS: "UPDATE_WIDGETS_MANDATORY_STATUS",

	RESET_COACH_CONSULT_STATE: "RESET_COACH_CONSULT_STATE",
	UPDATED_SECTION_CARD_COLLAPSE_STATUS: "UPDATED_SECTION_CARD_COLLAPSE_STATUS",

	FETCHED_PAST_APPOINTMENTS: "FETCHED_PAST_APPOINTMENTS",

	FETCH_PAST_PRESCRIPTIONS: "FETCH_PAST_PRESCRIPTIONS",

	UPDATE_STICKY_NOTE_TEXT: "UPDATE_STICKY_NOTE_TEXT",
	UPDATE_THINGS_TO_BUY: "UPDATE_THINGS_TO_BUY",
	UPDATE_PENDING_LOG_MARKERS: "UPDATE_PENDING_LOG_MARKERS",
	UPDATE_ACTIVE_DIET_PLAN_REMINDER_THEMES: "UPDATE_ACTIVE_DIET_PLAN_REMINDER_THEMES",
	UPDATE_PENDING_TASK_PROFILES: "UPDATE_PENDING_TASK_PROFILES",
	UPDATE_CURRENT_ACTIVE_PATIENT_GOALS_FOR_TASK_SCRIPTING: "UPDATE_CURRENT_ACTIVE_PATIENT_GOALS_FOR_TASK_SCRIPTING",
	UPDATE_CURRENT_ACTIVE_PATIENT_INTERVENTIONS_FOR_TASK_SCRIPTING: "UPDATE_CURRENT_ACTIVE_PATIENT_INTERVENTIONS_FOR_TASK_SCRIPTING",
	UPDATE_TASK_PROFILE_COMPLETION_STATUS: "UPDATE_TASK_PROFILE_COMPLETION_STATUS",
	UPDATE_COACH_CONSULTATION_STATUS: "UPDATE_COACH_CONSULTATION_STATUS",
	UPDATE_CURRENT_ASSIGNED_EXPERIMENTS: "UPDATE_CURRENT_ASSIGNED_EXPERIMENTS",
	UPDATE_NEW_ADDED_EXPERIMENTS: "UPDATE_NEW_ADDED_EXPERIMENTS",
	UPDATE_ALL_EXPERIMENT_LEVELS: "UPDATE_ALL_EXPERIMENT_LEVELS",
	UPADTE_AI_FITNESS_PLAN: "UPADTE_AI_FITNESS_PLAN",
}

export const FETCH_ALL_STATIC_DATA_SUCCESS_NEW = "FETCH_ALL_STATIC_DATA_SUCCESS_NEW"

export const InterventionActionsTypes = {
	UPDATE_PATIENT_INTERVENTION: "UPDATE_PATIENT_INTERVENTION",
	DELETE_PATIENT_INTERVENTION: "DELETE_PATIENT_INTERVENTION",
}
export const GoalsActionsTypes = {
	UPDATE_PATIENT_GOALS: "UPDATE_PATIENT_GOALS",
	UPDATE_PATIENT_GOALS_LAST_MODIFIED_DATE: "UPDATE_PATIENT_GOALS_LAST_MODIFIED_DATE",
	UPDATE_PATIENT_GOALS_METRIC: "UPDATE_PATIENT_GOALS_METRIC",
	UPDATE_PATIENT_GOAL_DELETED_IDS: "UPDATE_PATIENT_GOAL_DELETED_IDS",
	DELETE_PATIENT_GOAL_STATE: "DELETE_PATIENT_GOAL_STATE",
}

export const GoalsMetricActionsTypes = {}

export const DishNutritionInfoActionsTypes = {
	UPDATE_DISH_NUTRITION_INFO: "UPDATE_DISH_NUTRITION_INFO",
}

export const DietPlanActionsTypes = {
	UPDATE_DIET_PLAN_TO_STORE: "UPDATE_DIET_PLAN_TO_STORE",
	DELETE_DIET_PLAN_FROM_STORE: "DELETE_DIET_PLAN_FROM_STORE",
}

export const ChatActionNames = {
	SET_IS_CHATSIDEBAROPEN: "SET_IS_CHATSIDEBAROPEN",
	SET_NAMESPACE: "SET_NAMESPACE",
	SET_PATIENT_INFO: "SET_PATIENT_INFO",
	SET_IS_FULLSCREEN_MODE: "SET_IS_FULLSCREEN_MODE",
	SET_TOTAL_UNREAD_COUNT: "SET_TOTAL_UNREAD_COUNT",
	SET_USER_UNREAD_MESSAGE_MAP: "SET_USER_UNREAD_MESSAGE_MAP",
	SET_SHOW_ALL_GROUPS_CHAT_LIST: "SET_SHOW_ALL_GROUPS_CHAT_LIST",
	SET_ALL_GROUPS_ADMIN_IDS: "SET_ALL_GROUPS_ADMIN_IDS",
	SET_IS_CHAT_WINDOW_OPEN: "SET_IS_CHAT_WINDOW_OPEN",
}

export const UPDATE_RCA_USER_HEADER_DATA = "UPDATE_RCA_USER_HEADER_DATA"
export const UPDATE_RCA_COACH_DATA = "UPDATE_RCA_COACH_DATA"

export const UPDATE_RCA_PATIENT_LIST_FILTERS = "UPDATE_RCA_PATIENT_LIST_FILTERS"

export enum EventConfigActionType {
	UPDATE_ENABLE_EVENTS_FOR_ACCOUNTS = "UPDATE_ENABLE_EVENTS_FOR_ACCOUNTS",
}
export const UPDATE_TASK_MANAGER_SELECTED_TASK = "UPDATE_TASK_MANAGER_SELECTED_TASK"

export const VoipActionNames = {
	SET_VOIP_INSTANCE_ID: "SET_VOIP_INSTANCE_ID",
	SET_IS_VOIP_SESSION_ACTIVE: "SET_IS_VOIP_SESSION_ACTIVE",
	SET_VOIP_AUTH_TOKEN: "SET_VOIP_AUTH_TOKEN",
	SET_REDIAL_PAYLOAD: "SET_REDIAL_PAYLOAD",
	SET_AUTO_END_TIMEOUT: "SET_AUTO_END_TIMEOUT",
	SET_VOIP_USER_DATA: "SET_VOIP_USER_DATA",
}

export const AppConfigActionType = {
	UPDATE_HMS_RECORDING_COACH_LIST: "UPDATE_HMS_RECORDING_COACH_LIST",
	UPDATE_TRANSCRIPTION_ENABLED_AGENT_LIST: "UPDATE_TRANSCRIPTION_ENABLED_AGENT_LIST",
	UPDATE_CONSULT_AUDIO_RECORDING_DURATION_IN_SEC: "UPDATE_CONSULT_AUDIO_RECORDING_DURATION_IN_SEC",
	UPDATE_DOCTOR_IDS_TO_ENABLE_MEDICATION_SCORE_FEATURE: "UPDATE_DOCTOR_IDS_TO_ENABLE_MEDICATION_SCORE_FEATURE",
	UPDATE_CHS_METRIC_ID_MAP: "UPDATE_CHS_METRIC_ID_MAP",
	UPDATE_RATING_CONFIG: "UPDATE_RATING_CONFIG",
	UPDATE_WC_SCRIPT_TAGS_CONFIG: "UPDATE_WC_SCRIPT_TAGS_CONFIG",
	UPDATE_CHAT_FEATURE_CONFIG: "UPDATE_CHAT_FEATURE_CONFIG",
	UPDATE_AI_FEATURE_FLAGS_CONFIG: "UPDATE_AI_FEATURE_FLAGS_CONFIG",
	UPDATE_DOCTOR_IDS_TO_ENABLE_GLP_CARE_TEAM: "UPDATE_DOCTOR_IDS_TO_ENABLE_GLP_CARE_TEAM",
}

export const AudioChuckActionType = {
	PUSH_AUDIO_CHUCK: "PUSH_AUDIO_CHUCK",
	UPDATE_AUDIO_CHUCK: "UPDATE_AUDIO_CHUCK",
	RESET_AUDIO_CHUCKS: "RESET_AUDIO_CHUCKS",
	REMOVE_UPLOADED_CHUNKS: "REMOVE_UPLOADED_CHUNKS",
}

export const UserTimezoneActions = {
	UPDATE_USER_TIMEZONE: "UPDATE_USER_TIMEZONE",
	UPDATE_NATIONAL_TIMEZONE: "UPDATE_NATIONAL_TIMEZONE",
}
  

export const PsychologicalAssessmentActionsNames = {
	UPDATE_EVALUATION_FORM: "UPDATE_EVALUATION_FORM",
	UPDATE_INITIAL_EVALUATION_FORM: "UPDATE_INITIAL_EVALUATION_FORM",
}
